var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"form-loader"}},[(_vm.selectedConfig)?_c(_vm.activeComponent,_vm._b({tag:"component",on:{"onChangeConfig":_vm.onChangeConfig}},'component',{selectedConfig: _vm.selectedConfig, contentLoader: _vm.contentLoader, tenantSettings: _vm.tenantSettings},false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }